module.exports = __webpack_public_path__ + "static/bc-04-8af7304579017e514f0fb4865b1d9ea2.jpg";